import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import { Button, Select, Option, Message, Dropdown, DropdownMenu, Rate, DropdownItem, ColorPicker, Tree, Dialog, Input, Form, FormItem, Table, TableColumn, Row, Col, Breadcrumb, BreadcrumbItem, Loading, Checkbox, CheckboxGroup, Tabs, TabPane, Transfer, Pagination, InputNumber, Switch, Upload, Menu, Submenu, MenuItem, MenuItemGroup, Steps, Step, Radio, MessageBox, DatePicker } from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import '../static/icon/iconfont.css'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(ColorPicker)
Vue.use(Tree)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Row)
Vue.use(Col)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Transfer)
Vue.use(Pagination)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Radio)
Vue.use(Loading.directive)
Vue.use(DatePicker)
Vue.use(Rate);

Vue.prototype.$message = Message;
Vue.prototype.$messageBox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js